// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".view-about p a{color:#443fdb}.view-about .img-maria{width:31.25rem;height:auto;max-width:75%}", ""]);
// Exports
module.exports = exports;
